import React, { useMemo, useState } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import PrintIcon from '@mui/icons-material/Print';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { exportReportToExcel, exportReportToPdf, printReport } from '../../utils/reportExport';

const formatDateRange = (startDate, endDate) => {
  if (!startDate && !endDate) return 'N/A';
  if (startDate === endDate) return startDate;
  return `${startDate} to ${endDate}`;
};

export const ReportActionBar = ({
  title,
  data = [],
  columns = [],
  summary = [],
  startDate,
  endDate,
  fromTime,
  toTime,
  branchLabel,
  activeFilters = {},
  filename,
  onBack,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const filterSummary = useMemo(() => {
    const filters = {
      ...activeFilters,
      From: fromTime || '06:00',
      To: toTime || '22:00',
      'Date Range': formatDateRange(startDate, endDate),
      Branch: branchLabel || 'All Outlets',
    };

    return filters;
  }, [activeFilters, fromTime, toTime, startDate, endDate, branchLabel]);

  const handleExportExcel = () => {
    exportReportToExcel({
      title,
      data,
      columns,
      summary,
      filename,
    });
    setAnchorEl(null);
  };

  const handleExportPdf = () => {
    exportReportToPdf({
      title,
      data,
      columns,
      summary,
      reportPeriod: formatDateRange(startDate, endDate),
      branchLabel: branchLabel || 'All Outlets',
      filters: {
        'From Time': fromTime || '06:00',
        'To Time': toTime || '22:00',
        ...activeFilters,
      },
      filename,
    });
    setAnchorEl(null);
  };

  const handlePrintReport = () => {
    printReport({
      title,
      data,
      columns,
      summary,
      reportPeriod: formatDateRange(startDate, endDate),
      branchLabel: branchLabel || 'All Outlets',
      filters: {
        'From Time': fromTime || '06:00',
        'To Time': toTime || '22:00',
        ...activeFilters,
      },
    });
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<PrintIcon />}
        onClick={() => handlePrintReport()}
      >
        Print
      </Button>

      <Button
        variant="contained"
        color="primary"
        startIcon={<DownloadIcon />}
        endIcon={<ArrowDropDownIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        Export Excel
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={handleExportExcel}>Excel</MenuItem>
        <MenuItem onClick={handleExportPdf}>PDF</MenuItem>
        <MenuItem onClick={handlePrintReport}>Print Report</MenuItem>
      </Menu>

      {onBack && (
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
      )}
    </Box>
  );
};

export default ReportActionBar;
